
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M13 20a5.006 5.006 0 005-5V6.243a3.972 3.972 0 00-1.172-2.829l-2.242-2.242A3.972 3.972 0 0011.757 0H7a5.006 5.006 0 00-5 5v10a5.006 5.006 0 005 5zm-9-5V5a3 3 0 013-3s4.919.014 5 .024V4a2 2 0 002 2h1.976c.01.081.024 9 .024 9a3 3 0 01-3 3H7a3 3 0 01-3-3zm18-7v11a5.006 5.006 0 01-5 5H8a1 1 0 010-2h9a3 3 0 003-3V8a1 1 0 012 0z"}})])
          )
        }
      }
    